import React, { useState } from 'react';
import { Row, Col, Button, Form } from 'react-bootstrap';
import CityNameListData from "./property-data.json";

// HeroSearchForm component for filtering properties by location, type, and price
export default function HeroSearchForm() {
    
    // Store the list of city names from the data
    const [CityNameList] = useState(CityNameListData); 

    return (
        <>
            <Form className='hero-search-input'>
                {/* Row for the search form inputs */}
                <Row className='gx-2'>
                    <Col md={12}>
                        {/* Inner Row for location, property type, and price filters */}
                        <Row className='gx-2'>
                            {/* Location filter */}
                            <Col md={4}>
                                <div className="custom-form-input mb-md-0 mb-2">
                                    {/* Location icon */}
                                    <i className="bi bi-geo input-icon-s text-primary"></i>
                                    <Form.Select>
                                        <option>Convert any bedroom to addl.room with
very minimal cost</option>
                                        {/* Dynamically render city options from the CityNameList */}
                                        {/* {CityNameList.heroCityName.map((data, i) => (
                                            <option key={i} value={`${data.cityNameValue}`}>{data.cityName}</option>
                                        ))} */}
                                    </Form.Select>
                                </div>
                            </Col>
                            {/* Property type filter */}
                            <Col md={4}>
                                <div className="custom-form-input mb-md-0 mb-2">
                                    {/* House icon */}
                                    <i className="bi bi-house input-icon-s text-primary"></i>
                                    <Form.Select>
                                        <option>Spacious powder room</option>
                                        {/* Property type options */}
                                        {/* <option value="1">Land</option>
                                        <option value="2">Residential</option>
                                        <option value="3">Commercial</option>
                                        <option value="3">Industrial</option> */}
                                    </Form.Select>
                                </div>
                            </Col>
                            {/* Price filter */}
                            <Col md={4}>
                                <div className="custom-form-input mb-md-0 mb-2">
                                    {/* Currency icon */}
                                     <i className="bi bi-geo input-icon-s text-primary"></i>
                                    <Form.Select>
                                        <option>Open kitchen design</option>
                                        {/* Price range options */}
                                        {/* <option value="1">$500.00 - $1000.00</option>
                                        <option value="2">$1000.00 - $5000.00</option>
                                        <option value="3">$5000.00 - $10000.00</option> */}
                                    </Form.Select>
                                </div>
                            </Col>
                        </Row>
                    </Col>

                    {/* Search button */}
                     
                </Row>
            </Form>
        </>
    )
}
